/**
 * Every discrete capability in the system.
 *
 * Capability names encode their scope:
 *   *.any            – unrestricted
 *   *.ownLitigation  – scoped to litigations the actor is assigned to
 *   *.own            – scoped to resources owned by the actor
 *
 * String values match the PHP MemberCapability enum exactly.
 */
export enum MemberCapability {
    // -------------------------------------------------------------------------
    // Analysis – read
    // -------------------------------------------------------------------------

    ANALYSIS_READ_ANY = 'analysis.read.any',
    ANALYSIS_READ_OWN_LITIGATION = 'analysis.read.own_litigation',
    ANALYSIS_READ_OWN = 'analysis.read.own',
    ANALYSIS_READ_OWN_APPROVED = 'analysis.read.own_approved',

    // -------------------------------------------------------------------------
    // Analysis – edit (form fields / entries)
    // -------------------------------------------------------------------------

    ANALYSIS_EDIT_ANY = 'analysis.edit.any',
    ANALYSIS_EDIT_OWN_LITIGATION = 'analysis.edit.own_litigation',
    ANALYSIS_EDIT_OWN = 'analysis.edit.own',

    // -------------------------------------------------------------------------
    // Analysis – delete
    // -------------------------------------------------------------------------

    ANALYSIS_DELETE_ANY = 'analysis.delete.any',
    ANALYSIS_DELETE_OWN_LITIGATION = 'analysis.delete.own_litigation',
    ANALYSIS_DELETE_OWN = 'analysis.delete.own',
    ANALYSIS_DELETE_OWN_APPROVED = 'analysis.delete.own_approved',

    // -------------------------------------------------------------------------
    // Analysis – assign
    // -------------------------------------------------------------------------

    ANALYSIS_ASSIGN_ANY = 'analysis.assign.any',
    ANALYSIS_ASSIGN_OWN_LITIGATION = 'analysis.assign.own_litigation',

    // -------------------------------------------------------------------------
    // Analysis – status transitions
    // -------------------------------------------------------------------------

    ANALYSIS_CHECK_ANY = 'analysis.check.any',
    ANALYSIS_CHECK_OWN = 'analysis.check.own',
    ANALYSIS_FLAG_FOR_REVIEW = 'analysis.flag_for_review',
    ANALYSIS_APPROVE_ANY = 'analysis.approve.any',
    ANALYSIS_APPROVE_OWN_LITIGATION = 'analysis.approve.own_litigation',
    ANALYSIS_APPROVE_OWN = 'analysis.approve.own',

    // -------------------------------------------------------------------------
    // Litigation
    // -------------------------------------------------------------------------

    LITIGATION_CREATE = 'litigation.create',
    LITIGATION_EDIT_ANY = 'litigation.edit.any',
    LITIGATION_EDIT_OWN = 'litigation.edit.own',
    LITIGATION_EXPORT_ANY = 'litigation.export.any',
    LITIGATION_EXPORT_OWN = 'litigation.export.own',

    // -------------------------------------------------------------------------
    // Member management
    // -------------------------------------------------------------------------

    MEMBER_CREATE = 'member.create',
    MEMBER_EDIT_ANY = 'member.edit.any',
    MEMBER_EDIT_USER_LEVEL = 'member.edit.user_level',
    MEMBER_EDIT_OWN_PROFILE = 'member.edit.own_profile',
    MEMBER_EDIT_OWN_PASSWORD = 'member.edit.own_password',
    MEMBER_REQUIRE_PASSWORD_RESET = 'member.require_password_reset',
}
